import React, { useContext } from "react";
import { MultiSymbolMarginContext } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/MultiSymbolMargin.context.ts";
import { SymbolOption } from "@shared/features/bots/BotForm/MultiSymbolMarginSelector/types.ts";
import FlatList from "common/Lists/FlatList.tsx";
import SymbolRow from "features/bots/BotForm/MultiSymbolMargin/SymbolRow.tsx";
import EmptySymbols from "features/bots/BotForm/MultiSymbolMargin/EmptySymbols.tsx";

const SymbolsList = () => {
  const { symbolOptions } = useContext(MultiSymbolMarginContext)!;

  const getSymbolRow = ({ item }: { item: SymbolOption; index: number }) => {
    return <SymbolRow data={item} />;
  };

  return (
    <FlatList
      data={symbolOptions || []}
      renderContent={getSymbolRow}
      emptyState={<EmptySymbols />}
    />
  );
};

export default SymbolsList;
